import { DataTable, DataTableCollapsibleRow, FormInput, Heading, Loader } from "@/components"
import useViewGlDetails from "./useViewJobGlDetails";
import { activeLevels, cn, distributionLevels } from "@/lib/utils";
import { Button, TableCell, TableRow } from "@/components/ui";
import { CircleCheck, LockKeyhole } from "lucide-react";
import { FormProvider } from "react-hook-form";
import { CREATED_ON, RECEIVER, RULE, RUN_ON, RUN_STATUS, SOURCE, SOURCE_AMT, TABLE_DATA, TRIGGER_SOURCE } from "./consts";
import DetailCard from "./DetailCard";
import { ViewGroupGl } from "./ViewGroupGl";

const ViewJobGlDetails = () => {
  const {title, breadcrumbData, activeThresholdIndex, isLoadingFinancialInfo,
    form, columns, total, onLevelChange, activeLevelIndex, isBlockLevel,
    isPropertyLevel, isZoneLevel, parentColumns, onOpenGlDialog, openGroupGl, setOpenGroupGl,
    groupGlMasterId
  } = useViewGlDetails();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={title} breadcrumbData={breadcrumbData} />
        </div>
        <div className="flex flex-row gap-3 items-center">
          <span className="text-[20px] font-semibold text-primary">Plan</span>
        </div>
      </div>

      {isLoadingFinancialInfo ? 
        <Loader /> :
        <>
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between">
            <div className="mt-4 flex flex-wrap items-center gap-2">
              {activeLevels.map((item: any, index: number) => {
                const isUnlocked = index <= activeThresholdIndex;
                const isActive = activeLevelIndex == index;
                const isPrev = index < activeLevelIndex;

                return (
                  <Button
                    key={item.id}
                    type="button"
                    disabled={!isUnlocked}
                    className={cn(
                      "h-[40px] gap-1 px-3 bg-transparent shadow-none border-1 border-primary",
                      // isActive && "bg-white hover:bg-white shadow-xl",
                      isActive && "bg-primary hover:bg-primary text-white hover:text-white",
                      !isUnlocked && "bg-gray-400 hover:bg-gray-400 border-gray-400 text-gray-800" 
                    )}
                    variant="outline"
                    onClick={onLevelChange(item.value)}
                  >
                    {isUnlocked ? isPrev ? <CircleCheck className="fill-green-600 stroke-white h-6 w-6" /> : <></> : <LockKeyhole />}
                    {item.label}
                  </Button>
                );
              })}
            </div>
            <Button variant="link" onClick={onOpenGlDialog}>View Group GL(s)</Button>
          </div>

          <FormProvider {...form}>
            <form>
              <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[30px] my-[30px]">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-[20px]">
                  <FormInput
                    name={SOURCE}
                    control={form.control}
                    label="Source Level"
                    placeholder="Please enter"
                    disabled
                  />
                  <FormInput
                    name={RECEIVER}
                    control={form.control}
                    label="Receiver Level"
                    placeholder="Please enter"
                    disabled
                  />
                  <FormInput
                    name={SOURCE_AMT}
                    control={form.control}
                    label="Source Amount"
                    placeholder="Please enter"
                    disabled
                    startIcon="$"
                  />
                  <FormInput
                    name={RUN_STATUS}
                    control={form.control}
                    label="Run Status"
                    placeholder="Please enter"
                    disabled
                  />
                  <DetailCard label="Rule" value={distributionLevels[form.getValues(RULE)]} />
                  <DetailCard label="Trigger Source" value={form.getValues(TRIGGER_SOURCE)} />
                  <DetailCard label="Created On" value={form.getValues(CREATED_ON)} />
                  <DetailCard label="Run On" value={form.getValues(RUN_ON)} />
                </div>
              </div>

              {isZoneLevel ?
                <DataTable
                  data={form.getValues(TABLE_DATA) || []}
                  columns={columns}
                  hideFooter
                  className="mt-2 w-full"
                  tableWrapperClassName="px-0"
                  lastRow={
                    <TableRow
                      key={`total-row`}
                      className={cn(
                        "border-g-200 bg-primary text-white hover:bg-primary",
                      )}
                    >
                      <TableCell
                        key={`total-cell-1`}
                        className="text-right h-[45px]"
                        style={{ width: "auto" }}
                      >
                        Total
                      </TableCell>
                      <TableCell
                        key={`total-cell-1`}
                        className="text-left h-[45px]"
                        style={{ width: "auto" }}
                      >
                        {total.metricValue}
                      </TableCell>
                      <TableCell
                        key={`total-cell-1`}
                        className="text-left h-[45px]"
                        style={{ width: "auto" }}
                      >
                        {total.share}
                      </TableCell>
                      <TableCell
                        key={`total-cell-1`}
                        className="text-left h-[45px]"
                        style={{ width: "auto" }}
                      >
                        {total.amt}
                      </TableCell>
                    </TableRow>
                  }
                /> : 
                <DataTableCollapsibleRow
                  columns={isPropertyLevel || isBlockLevel ? parentColumns : columns}
                  nestedColumns={[isPropertyLevel ? parentColumns : columns, columns]}
                  data={form.getValues(TABLE_DATA) || []}
                  containerClassName="border-0 shadow-none"
                />
              }
            </form>
          </FormProvider>
        </>
      }
      {openGroupGl && <ViewGroupGl open={openGroupGl} setOpen={setOpenGroupGl} groupGlMasterId={groupGlMasterId} />}
    </div>
  )
}

export default ViewJobGlDetails;